import './FrontB.sass';
import heroL from '../assets/hero/front-b-l.jpg';
import Hero from '../components/Hero';
import Breadcrumbs from '../components/Breadcrumbs';

const FrontBTrophy = () => {
	return (
		<div className='FrontB'>
			<Hero data={[{ pic: heroL, description: '大華銀投信' }]} />

			<Breadcrumbs
				data={[
					{ url: '', name: '麵包屑', guid: 'a' },
					{ url: '', name: '麵包屑', guid: 'b' },
				]}
			/>

			<div className='common-pad-wrap'>
				<div className='content'>
					<div className='customized trophy'>
						<div className='icon-title'>
							<div className='icon'>
								<img src='/assets/about-us/icon-trophy.svg' alt='' />
							</div>

							<div className='text'>在台核備新加坡大華系列基金之獲獎紀錄</div>
						</div>

						<p>
							大華銀投信傳承新加坡大華資產管理具備的國際色彩以及在亞洲資產管理獨具的投資優勢，深耕台灣在地市場，矢志將台灣打造為大中華區營運及投資的平台，成為大中華區投資管理的樞紐。整合大華資產管理的投資研究資源，建立在地投資團隊並持續強化在地人才培養，提供國內投資人大華銀投信特色的創新產品及優質投資策略，帶給國內本土基金市場更加豐富的選擇。
						</p>

						<div className='section'>
							<div className='section-title'>新加坡大華全球保健基金</div>
							<div className='timeline'>
								<div className='row'>
									<div className='line'></div>
									<div className='dot'></div>
									<div className='year'>2018年</div>
									<div className='text-group'>
										<div className='text'>理柏台灣基金獎 最佳醫藥及健康護理股票基金【五年期、十年期】</div>
									</div>
								</div>

								<div className='row'>
									<div className='line'></div>
									<div className='dot'></div>
									<div className='year'>2017年</div>
									<div className='text-group'>
										<div className='text'>理柏台灣基金獎 最佳醫藥及健康護理股票基金【三年期】</div>
									</div>
								</div>

								<div className='row'>
									<div className='line'></div>
									<div className='dot'></div>
									<div className='year'>2016年</div>
									<div className='text-group'>
										<div className='text'>Smart智富台灣基金獎 生物科技和健康護理基金【三年期】</div>
										<div className='text'>理柏台灣基金獎 最佳醫藥及健康護理股票基金【十年期】</div>
									</div>
								</div>

								<div className='row'>
									<div className='line'></div>
									<div className='dot'></div>
									<div className='year'>2015年</div>
									<div className='text-group'>
										<div className='text'>理柏台灣基金獎 最佳醫藥及健康護理股票基金【十年期】</div>
									</div>
								</div>

								<div className='row'>
									<div className='line'></div>
									<div className='dot'></div>
									<div className='year'>2014年</div>
									<div className='text-group'>
										<div className='text'>理柏新加坡基金獎 最佳醫藥及健康護理股票基金【五年期、十年期】</div>
									</div>
								</div>

								<div className='row'>
									<div className='line'></div>
									<div className='dot'></div>
									<div className='year'>2013年</div>
									<div className='text-group'>
										<div className='text'>理柏新加坡基金獎 最佳醫藥及健康護理股票基金【三年期、五年期、十年期】</div>
										<div className='text'>理柏台灣基金獎 最佳醫藥及健康護理股票基金【五年期】</div>
									</div>
								</div>

								<div className='row'>
									<div className='line'></div>
									<div className='dot'></div>
									<div className='year'>2011年</div>
									<div className='text-group'>
										<div className='text'>理柏台灣基金獎 最佳醫藥及健康護理股票基金【五年期】</div>
									</div>
								</div>

								<div className='row'>
									<div className='line'></div>
									<div className='dot'></div>
									<div className='year'>2010年</div>
									<div className='text-group'>
										<div className='text'>理柏台灣基金獎 最佳醫藥及健康護理股票基金【五年期】</div>
									</div>
								</div>
							</div>
						</div>

						<div className='section'>
							<div className='section-title'>新加坡大華黃金及綜合基金</div>
							<div className='timeline'>
								<div className='row'>
									<div className='line'></div>
									<div className='dot'></div>
									<div className='year'>2019年</div>
									<div className='text-group'>
										<div className='text'>Smart智富台灣基金獎 資源、生態、替代能源股票型基金獎【五年期、十年期】</div>
									</div>
								</div>

								<div className='row'>
									<div className='line'></div>
									<div className='dot'></div>
									<div className='year'>2010年</div>
									<div className='text-group'>
										<div className='text'>理柏台灣基金獎 最佳黃金及貴金屬股票基金【三年期】</div>
									</div>
								</div>

								<div className='row'>
									<div className='line'></div>
									<div className='dot'></div>
									<div className='year'>2009年</div>
									<div className='text-group'>
										<div className='text'>理柏台灣基金獎 最佳黃金及貴金屬股票基金【三年期、五年期】</div>
									</div>
								</div>

								<div className='row'>
									<div className='line'></div>
									<div className='dot'></div>
									<div className='year'>2003年</div>
									<div className='text-group'>
										<div className='text'>Edge-Lipper 新加坡基金獎 最佳其他產業股票基金【三年期】</div>
									</div>
								</div>
							</div>
						</div>

						<div className='section'>
							<div className='section-title'>新加坡大華新興市場債券基金 (本基金主要係投資於非投資等級之高險債券且配息可能涉及本金)</div>
							<div className='timeline'>
								<div className='row'>
									<div className='line'></div>
									<div className='dot'></div>
									<div className='year'>2017年</div>
									<div className='text-group'>
										<div className='text'>最佳固定收益管理團隊-晨星最佳基金(新加坡)</div>
										<div className='text'>金鑽獎 最佳債券型基金【十年期】</div>
									</div>
								</div>

								<div className='row'>
									<div className='line'></div>
									<div className='dot'></div>
									<div className='year'>2016年</div>
									<div className='text-group'>
										<div className='text'>金鑽獎 最佳環球新興市場債券基金【十年期】</div>
									</div>
								</div>

								<div className='row'>
									<div className='line'></div>
									<div className='dot'></div>
									<div className='year'>2015年</div>
									<div className='text-group'>
										<div className='text'>金鑽獎 最佳環球新興市場債券基金【十年期】</div>
									</div>
								</div>

								<div className='row'>
									<div className='line'></div>
									<div className='dot'></div>
									<div className='year'>2014年</div>
									<div className='text-group'>
										<div className='text'>金鑽獎 最佳環球新興市場債券基金【十年期】</div>
									</div>
								</div>

								<div className='row'>
									<div className='line'></div>
									<div className='dot'></div>
									<div className='year'>2012年</div>
									<div className='text-group'>
										<div className='text'>金鑽獎 最佳環球新興市場債券基金【五年期、十年期】</div>
									</div>
								</div>

								<div className='row'>
									<div className='line'></div>
									<div className='dot'></div>
									<div className='year'>2011年</div>
									<div className='text-group'>
										<div className='text'>金鑽獎 最佳環球新興市場債券基金【三年期、五年期】</div>
										<div className='text'>理柏台灣基金獎 最佳環球新興市場債券基金【三年期】</div>
									</div>
								</div>
							</div>
						</div>

						<div className='section'>
							<div className='section-title'>新加坡大華全球金融基金</div>
							<div className='timeline'>
								<div className='row'>
									<div className='line'></div>
									<div className='dot'></div>
									<div className='year'>2013年</div>
									<div className='text-group'>
										<div className='text'>理柏新加坡基金獎 最佳銀行金融股票基金【三年期】</div>
									</div>
								</div>

								<div className='row'>
									<div className='line'></div>
									<div className='dot'></div>
									<div className='year'>2010年</div>
									<div className='text-group'>
										<div className='text'>理柏台灣基金獎 最佳銀行金融股票基金【三年期】</div>
									</div>
								</div>

								<div className='row'>
									<div className='line'></div>
									<div className='dot'></div>
									<div className='year'>2005年</div>
									<div className='text-group'>
										<div className='text'>新加坡標準普爾投資 最佳全球金融股票基金獎【三年期】</div>
									</div>
								</div>

								<div className='row'>
									<div className='line'></div>
									<div className='dot'></div>
									<div className='year'>2004年</div>
									<div className='text-group'>
										<div className='text'>新加坡標準普爾投資 最佳全球金融股票基金獎【三年期】</div>
									</div>
								</div>
							</div>
						</div>

						<div className='section'>
							<div className='section-title'>新加坡大華全球科技基金</div>
							<div className='timeline'>
								<div className='row'>
									<div className='line'></div>
									<div className='dot'></div>
									<div className='year'>2009年</div>
									<div className='text-group'>
										<div className='text'>理柏台灣基金獎 最佳資訊科技股票基金【十年期】</div>
									</div>
								</div>

								<div className='row'>
									<div className='line'></div>
									<div className='dot'></div>
									<div className='year'>2008年</div>
									<div className='text-group'>
										<div className='text'>台灣金鑽獎 最佳資訊科技股票基金【十年期】</div>
									</div>
								</div>
							</div>
						</div>

						<div className='section'>
							<div className='section-title'>新加坡大華國際成長基金</div>
							<div className='timeline'>
								<div className='row'>
									<div className='line'></div>
									<div className='dot'></div>
									<div className='year'>2009年</div>
									<div className='text-group'>
										<div className='text'>新加坡Edge-Lipper單位信託 最佳全球股票基金獎【五年期】</div>
									</div>
								</div>

								<div className='row'>
									<div className='line'></div>
									<div className='dot'></div>
									<div className='year'>2006年</div>
									<div className='text-group'>
										<div className='text'>新加坡Edge-Lipper單位信託 最佳全球股票基金獎【五年期】</div>
										<div className='text'>新加坡標準普爾投資 最佳全球股票基金獎【五年期】</div>
									</div>
								</div>

								<div className='row'>
									<div className='line'></div>
									<div className='dot'></div>
									<div className='year'>2005年</div>
									<div className='text-group'>
										<div className='text'>新加坡標準普爾投資 最佳全球股票基金獎【五年期】</div>
									</div>
								</div>

								<div className='row'>
									<div className='line'></div>
									<div className='dot'></div>
									<div className='year'>2004年</div>
									<div className='text-group'>
										<div className='text'>台灣金鑽獎 最佳全球股票基金獎【三年期】</div>
										<div className='text'>新加坡標準普爾投資 最佳全球股票基金獎【五年期】</div>
									</div>
								</div>

								<div className='row'>
									<div className='line'></div>
									<div className='dot'></div>
									<div className='year'>2003年</div>
									<div className='text-group'>
										<div className='text'>新加坡Edge-Lipper單位信託 最佳全球股票基金獎【五年期】</div>
										<div className='text'>新加坡標準普爾投資 最佳全球股票基金獎【五年期】</div>
									</div>
								</div>

								<div className='row'>
									<div className='line'></div>
									<div className='dot'></div>
									<div className='year'>2000年</div>
									<div className='text-group'>
										<div className='text'>新加坡標準普爾投資 最佳全球股票基金獎【五年期】</div>
									</div>
								</div>
							</div>
						</div>

						<div className='section'>
							<div className='section-title'>新加坡大華日本成長基金</div>
							<div className='timeline'>
								<div className='row'>
									<div className='line'></div>
									<div className='dot'></div>
									<div className='year'>2004年</div>
									<div className='text-group'>
										<div className='text'>標準普爾台灣基金獎 最佳日本股票【五年期】</div>
									</div>
								</div>

								<div className='row'>
									<div className='line'></div>
									<div className='dot'></div>
									<div className='year'>2003年</div>
									<div className='text-group'>
										<div className='text'>新加坡Edge-Lipper單位信託 最佳日本股票基金獎【五年期】</div>
									</div>
								</div>

								<div className='row'>
									<div className='line'></div>
									<div className='dot'></div>
									<div className='year'>2002年</div>
									<div className='text-group'>
										<div className='text'>標準普爾台灣基金獎 最佳日本股票【三年期】</div>
										<div className='text'>新加坡標準普爾投資 最佳日本股票基金獎【三年期】</div>
									</div>
								</div>
							</div>
						</div>

						<div className='section'>
							<div className='section-title'>新加坡大華亞洲基金</div>
							<div className='timeline'>
								<div className='row'>
									<div className='dot'></div>
									<div className='year'>2008年</div>
									<div className='text-group'>
										<div className='text'>Edge-Lipper新加坡基金獎 最佳亞洲股票基金</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default FrontBTrophy;
